import { render } from "./ReportActivitiesView.vue?vue&type=template&id=bb80117e&scoped=true"
import script from "./ReportActivitiesView.vue?vue&type=script&lang=js"
export * from "./ReportActivitiesView.vue?vue&type=script&lang=js"

import "./ReportActivitiesView.vue?vue&type=style&index=0&id=bb80117e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb80117e"]])

export default __exports__